import React, {Component} from "react";
import axios from "axios";
import TextField from "@material-ui/core/TextField";
import {
  RESERVE_RESULT_LINK,
  LOGIN_LINK,
  ROOM_LIST_URL,
  ROOM_RESERVE_URL,
  CHECK_TOKEN_URL,
  LOGIN_SUCCESS, LOGIN_ERROR
} from "../actions/types";
import {DatePicker, TimePicker, MuiPickersUtilsProvider} from "material-ui-pickers";
import EditIcon from "@material-ui/icons/Edit.js";
import MomentUtils from "@date-io/moment";
import IconCount from "../images/icon_count_white.svg";
import IconVideo from "../images/icon_video_white.svg";
import IconLaptop from "../images/icon_laptop_white.svg";
import IconBlackboard from "../images/icon_blackboard_white.svg";
import Iconspeaker from "../images/icon_speaker_white.svg";
import BackToUpperLevel from "./BackToUpperLevel.js";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import "moment/locale/zh-cn";
//
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FilledInput from '@material-ui/core/FilledInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
//
moment.locale("zh-cn");

class RoomDetailForm extends Component {
  state = {
    room: this.props.location.state ? this.props.location.state.room : {},
    allMeetingRoom: [],
    startDate: null,
    startTime: null,
    endTime: null,
    reserveName: "",
    reserveDesc: "",
    reservePersonNum: "",
    reserveOther: "",
    filter: false,
    open: false,
    errMessage: "",
    daylimit: 14,

    appointmentPhone: "",
    meetingType: -1,
    meetingTypeDescribe: "",
    appointment: "",
    userInfo: {flag: true}
  };

  componentDidMount() {
    document.body.style.position = "fixed";
    let _this = this;
    // 获得房间列表
    axios({
      method: "get",
      url: `${ROOM_LIST_URL}`,
    })
      .then(res => {
        this.setState({allMeetingRoom: res.data});
      })
      .catch(err => {
        console.log(err);
      });
    // 获得用户信息
    axios({
      method: "get",
      url: `${CHECK_TOKEN_URL}`,
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("X-AUTH-TOKEN")
      }
    }).then(function (res) {
      console.log(res.data.userInfo, "---");
      _this.setState({appointmentPhone: res.data.userInfo.mobile});
      _this.setState({appointment: res.data.userInfo.name});
    }).catch(err => {
    });

    axios({
      method: "get",
      url: `${CHECK_TOKEN_URL}`,
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("X-AUTH-TOKEN")
      }
    }).then(function (res) {
      console.log(res)
      _this.setState({userInfo: res.data.userInfo});
    }).catch(err => {
    })
  }

  componentWillUnmount() {
    document.body.style.position = "";
    this.setState = (state, callback) => {
      return;
    };
  }

  componentWillUpdate(nextProps) {
    if (nextProps.location.state) {
      let {timeStamp} = nextProps.location.state;
      let nowTimeStamp = new Date().valueOf();
      if (nextProps.location.state.timeStamp && timeStamp + 3600000 > nowTimeStamp) {
        if (!this.state.startDate) {
          this.setState({startDate: moment(nextProps.location.state.timeStamp)});
        }
      }
    }
  }

  handleDate = date => {
    let end = moment();
    end.add(this.state.daylimit, "days");
    if (end < date && this.state.userInfo.flag) {
      return alert(`请选择${this.state.daylimit}天以内的时间进行预约。`);
    } else {
      this.setState({startDate: date});
    }
  };
  handleStart = date => {
    console.log("this.state.startTime", date > this.state.endTime);
    let start = moment(moment(date).format('YYYY-MM-DD 08:00'));
    let end = moment(moment(date).format('YYYY-MM-DD 22:01'));
    console.log(start.format('YYYY-MM-DD HH:mm'),end.format('YYYY-MM-DD HH:mm'),date.format('YYYY-MM-DD HH:mm'))
    // check
    if (!(date >= start && date <= end)) {
      alert("请选择8:00-22:00内的时间段预约!")
    } else {
      this.setState({startTime: date});
    }
    return;
    if (!this.state.endTime || date > this.state.endTime) {
      this.setState({endTime: date});
    }
  };
  handleEnd = date => {
    let start = moment(moment(date).format('YYYY-MM-DD 08:00'));
    let end = moment(moment(date).format('YYYY-MM-DD 22:01'));
    // check
    if (!(date >= start && date <= end)) {
      alert("请选择8:00-22:00内的时间段预约!")
    } else {
      this.setState({endTime: date});
    }
    return;
    if (!this.state.startTime) {
      this.setState({startTime: date});
    }
  };
  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({open: false});
  };
  handleChange = event => {
    this.setState({value: event.target.value});
  };

  submitReserve() {
    const {
      startDate,
      startTime,
      endTime,
      convener,
      reservePersonNum,
      reserveName,
      reserveDesc,
      reserveOther,
      room,
      appointmentPhone,
      meetingType,
      meetingTypeDescribe,
      appointment
    } = this.state;
    const DateTimeStamp = moment(startDate.format("YYYY-MM-DD")).valueOf();
    const startTimeStamp = DateTimeStamp + startTime.hour() * 60 * 60 * 1000 + startTime.minutes() * 60 * 1000;
    const endTimeStamp = DateTimeStamp + endTime.hour() * 60 * 60 * 1000 + endTime.minutes() * 60 * 1000;
    if (appointmentPhone) {
      if (!(/^1[3456789]\d{9}$/.test(appointmentPhone) || /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(appointmentPhone))) {
        alert('手机号码有误，请重填');
        return false;
      }
    }
    if (meetingType == -1) {
      alert("请选择会议类型");
      return;
    }
    if (meetingType == 0 && meetingTypeDescribe.length == 0) {
      alert("请填写会议描述");
      return;
    }
    if (endTimeStamp <= startTimeStamp) {
      alert("结束时间不能小于开始时间");
      return;
    }
    if (startDate._d <= new Date() && startTime._d <= new Date()) {
      alert("开始时间不能小于当前时间");
      return;
    }
    if (room.id === undefined) {
      this.setState({errMessage: "请选择会议室", open: true});
      return;
    }
    let data = {
      date: startDate.format("YYYY-MM-DD"),
      description: reserveDesc,
      convener: convener,
      purpose: reserveName,
      remark: reserveOther,
      end: endTimeStamp,
      start: startTimeStamp,
      count: parseInt(reservePersonNum),
      appointmentPhone, meetingType, meetingTypeDescribe, appointment
    };
    axios({
      method: "post",
      url: `${ROOM_RESERVE_URL}/${room.id}`,
      data: data,
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("X-AUTH-TOKEN")
      }
    }).then(res => {
      if (res.data.code === 200) {
        this.props.history.push(`${RESERVE_RESULT_LINK}/success/${this.state.room.needApproval ? 1 : 0}`);
      } else {
        this.setState({errMessage: res.data.message, open: true});
      }
    }).catch(err => {
      this.props.history.push(LOGIN_LINK)
    })
  }

  render() {
    // this.props.history.push(`${RESERVE_RESULT_LINK}/success/${false ? 1 : 0}`);
    const {
      startDate,
      startTime,
      endTime,
      convener,
      reserveName,
      reserveDesc,
      reservePersonNum,
      meetingType
    } = this.state;
    let isDisabled = meetingType === -1 || reservePersonNum === '' || startDate === null || startTime === null || endTime === null || convener === "" || (reserveName === "" || reserveDesc === "");
    return (
      <React.Fragment>
        <BackToUpperLevel title="预约" history={this.props.history}/>
        <div className="room-reserve">
          <section className="room-scroll">
            {this.renderReserveContent()}
            <form className="room-form" noValidate autoComplete="off">
              <MuiPickersUtilsProvider utils={MomentUtils} style={{marginTop: "4px"}}>
                <DatePicker
                  // onClick={()=>this.fixedBody()}
                  id="reserve-time" label="预约日期*" fullWidth margin="normal" variant="outlined"
                  onChange={this.handleDate} value={startDate} disablePast={true} cancelLabel="取消" okLabel="确定"/>
                <TimePicker label="开始时间*" margin="normal" variant="outlined" className="date-picker"
                            onChange={this.handleStart} value={startTime} style={{marginRight: "4%"}} cancelLabel="取消"
                            okLabel="确定"/>
                <TimePicker label="结束时间*" margin="normal" variant="outlined" className="date-picker"
                            onChange={this.handleEnd} value={endTime} cancelLabel="取消" okLabel="确定"/>
              </MuiPickersUtilsProvider>
              <TextField id="reserve-convener" label="会议召集人*" fullWidth margin="normal" variant="outlined"
                         onChange={e => {
                           this.setState({convener: e.target.value});
                         }}
              />
              <TextField id="reserve-name" label="会议名称*" fullWidth margin="normal" variant="outlined" onChange={e => {
                this.setState({reserveName: e.target.value});
              }}
              />
              <TextField id="reserve-desc" label="会议说明*" fullWidth multiline margin="normal" variant="outlined"
                         onChange={e => {
                           if (e.target.value.length > 500) {
                             alert('输入字数不能大于500字')
                             return
                           }
                           this.setState({reserveDesc: e.target.value});
                         }}
              />
              <TextField
                id="reserve-number"
                label="会议人数*"
                fullWidth
                multiline
                margin="normal"
                variant="outlined"
                onChange={e => {
                  this.setState({reservePersonNum: e.target.value});
                }}/>
              <FormControl variant="outlined" style={{width: "100%"}}>
                <InputLabel htmlFor="outlined-age-native-simple">请选择会议类型*</InputLabel>
                <Select
                  value={this.state.meetingType == -1 ? "" : this.state.meetingType}
                  onChange={(event) => {
                    this.setState({meetingType: event.target.value});
                  }}
                  input={<OutlinedInput name="age" labelWidth={this.state.labelWidth} id="outlined-age-native-simple"/>}
                >
                  {
                    [
                      {name: "学术报告", value: "0"},
                      {name: "组会", value: "1"},
                      {name: "学生答辩", value: "2"},
                      {name: "学生活动", value: "3"},
                      {name: "党务会议", value: "4"},
                      {name: "学院层面业务会议", value: "5"},
                      {name: "其它", value: "6"},
                    ].map(({name, value}) => {
                      return <MenuItem value={value}>{name}</MenuItem>
                    })
                  }
                </Select>
              </FormControl>
              {meetingType == 0 &&
              <TextField id="reserve-meetingTypeDescribe" label="学术报告描述*" fullWidth multiline margin="normal"
                         variant="outlined"
                         onChange={e => {
                           if (e.target.value.length > 500) {
                             alert('输入字数不能大于500字')
                             return
                           }
                           this.setState({meetingTypeDescribe: e.target.value});
                         }}/>}
              <TextField id="reserve-phone" label="预约人" fullWidth multiline margin="normal" variant="outlined"
                         value={this.state.appointment}
                         onChange={e => {
                           this.setState({appointment: e.target.value});
                         }}/>
              <TextField id="reserve-phone" label="预约人电话" fullWidth multiline margin="normal" variant="outlined"
                         value={this.state.appointmentPhone}
                         onChange={e => {
                           this.setState({appointmentPhone: e.target.value});
                         }}/>
              <TextField
                id="reserve-other" label="备注" fullWidth multiline margin="normal" variant="outlined"
                onChange={e => {
                  if (e.target.value.length > 500) {
                    alert('输入字数不能大于500字')
                    return
                  }
                  this.setState({reserveOther: e.target.value});
                }}/>
              <div className="week-submit-contain">
                {isDisabled ? (<div className="week-submit" style={{background: "rgba(0,0,0,0.25)"}}>提交</div>) : (
                  <div className="week-submit" onClick={() => this.submitReserve()}>提交</div>)}
              </div>
            </form>
          </section>
        </div>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }} className="room-snackBar"
          open={this.state.open} autoHideDuration={6000} onClose={this.handleClose}
          message={<span>{this.state.errMessage || "预约失败"}</span>}
          action={[
            <IconButton key="close" aria-label="Close" color="inherit" onClick={this.handleClose}>
              <CloseIcon/>
            </IconButton>
          ]}
        />
        {this.renderFilterDiv()}
      </React.Fragment>
    );
  }

  renderReserveContent() {
    const {room} = this.state;
    if (room.id) {
      let photoUrl = "";
      let photoArr = room.mediaList.filter(data => {
        return data.type === "photo";
      });
      if (photoArr.length !== 0) {
        photoUrl = photoArr[0].url;
      }
      return (<section className="reserve-content room-desc">
        <div className="reserve-left">
          <div className="reserve-area">
							<span style={{fontSize: 20, lineHeight: "22px"}}
                    onClick={() => this.setState({filter: true})}>
								<span>{room.name}</span>
								<EditIcon style={{fontSize: 16, verticalAlign: "middle", marginLeft: 4}}/>
							</span>
          </div>
          <div className="reserve-time">
            <img style={{verticalAlign: "middle", marginRight: 5}} src={IconCount} alt="icon" height={14}/>
            <span style={{verticalAlign: "middle"}}>{room.capacity}人</span>
          </div>
          <div className="reserve-status">
            {room.projector_status && <img src={IconVideo} alt="icon" height={14}/>}
            {room.computer_status && <img src={IconLaptop} alt="icon" height={14}/>}
            {room.board_status && <img src={IconBlackboard} alt="icon" height={14}/>}
            {room.soundDevice_status && <img src={Iconspeaker} alt="icon" height={15}/>}
          </div>
        </div>
        <div className="reserve-room-img" style={{backgroundImage: `url(${photoUrl})`}}/>
      </section>);
    } else {
      return (<section className="reserve-content room-desc">
        <div className="reserve-selectRoom" style={{minHeight: 72}}
             onClick={() => this.setState({filter: true})}>
          <span style={{display: "inline-block", verticalAlign: "middle"}}>选择会议室</span>
          <EditIcon style={{fontSize: 16, verticalAlign: "middle", marginLeft: 4}}/>
        </div>
      </section>);
    }
  }

  // 渲染选择会议室
  renderFilterDiv() {
    const {allMeetingRoom, filter} = this.state;
    return (
      <div className="filter-div" style={{transform: filter ? "scale(1)" : "scale(0)"}}>
        <div className="filter-top">
          <div className="filter-close" onClick={() => this.setState({filter: false})}>
            <CloseIcon style={{fontSize: 14, verticalAlign: "middle"}}/>
          </div>
          <span>选择会议室</span>
        </div>
        <div className="filter-contain">
          {allMeetingRoom.map((room, idx) => {
            return (
              <div className="select-room-div" onClick={() => this.selectDetailRoom(room)} key={idx}>
                {room.name}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  selectDetailRoom(room) {
    this.setState({room: room, filter: false});
  }
}

export default RoomDetailForm;
